module.exports = __webpack_public_path__ + "media/images/flags/64/Western-Sahara-d3e83c11ea0b03eb5361de8f22da9b3a.png";